import { useSyncExternalStore } from "react";
import type { Locales } from "~/i18n/i18n-types";

const LOCALE_KEY = "language";
const DEFAULT_LOCALE: Locales = "en";

function getSnapshot(): Locales {
	return (localStorage.getItem(LOCALE_KEY) as Locales) ?? DEFAULT_LOCALE;
}

function getServerSnapshot(): Locales {
	return DEFAULT_LOCALE;
}

function subscribe(callback: () => void): () => void {
	const handler = (e: StorageEvent) => {
		if (e.key === LOCALE_KEY) {
			callback();
		}
	};
	window.addEventListener("storage", handler);
	return () => window.removeEventListener("storage", handler);
}

export function useLocale(): Locales {
	return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function setStoredLocale(locale: Locales) {
	localStorage.setItem(LOCALE_KEY, locale);
	window.dispatchEvent(new StorageEvent("storage", { key: LOCALE_KEY }));
}
